import { render, staticRenderFns } from "./ShareModal.vue?vue&type=template&id=37070546&scoped=true&"
import script from "./ShareModal.vue?vue&type=script&lang=js&"
export * from "./ShareModal.vue?vue&type=script&lang=js&"
import style0 from "./ShareModal.vue?vue&type=style&index=0&id=37070546&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37070546",
  null
  
)

export default component.exports